import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=3013006c&"
import script from "./Milestone.vue?vue&type=script&lang=js&"
export * from "./Milestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3013006c')) {
      api.createRecord('3013006c', component.options)
    } else {
      api.reload('3013006c', component.options)
    }
    module.hot.accept("./Milestone.vue?vue&type=template&id=3013006c&", function () {
      api.rerender('3013006c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/Row/Milestone.vue"
export default component.exports